export const clientConfig = {
    webApiProtocol: 'https://',
    webApiUrl: 'enki.adwudlit.uni-mainz.de',
    webApiPort: '8443',
    webServiceUrl: 'localhost',
    webServicePort: '5000',
};
